import { getDeviceSize } from '~/utils/device'
import debounce from 'lodash-es/debounce'

export default {
  props: {
    title: {
      type: String,
    },
    description: {
      type: String,
    },
    data: {
      type: [Array, Object],
      required: true,
    },
    dataAttributes: {
      type: [Array, Object],
    },
  },

  data() {
    return {
      currentTab: null,
      items: [],
      isDesktop: null,
      hasDeviceSize: false,
    }
  },

  created() {
    this.items = this.data
  },

  computed: {},

  mounted() {
    this.currentTab = this.items[0]

    this.$nextTick(() => {
      window.addEventListener('resize', this.resize)

      window.dispatchEvent(new Event('resize'))
      this.checkDeviceSize()
    })
  },

  beforeDestroy() {
    window.removeEventListener('resize', this.resize)
  },

  methods: {
    checkDeviceSize() {
      const device = getDeviceSize()
      if (/desktop(?:\-(?:xl|[lm]))?/.test(device)) {
        this.isDesktop = true
        this.hasDeviceSize = true
      } else {
        this.isDesktop = false
        this.hasDeviceSize = true
      }
    },

    resize(e) {
      this.resizeDebounce(e, this)
    },

    changeTab(index) {
      this.currentTab = this.items[index]
    },

    isActive(index) {
      return this.currentTab === this.items[index] ? true : false
    },

    resizeDebounce: debounce((e, self) => {
      const deviceSize = getDeviceSize()

      if (/desktop(?:\-(?:xl|[lm]))?/.test(deviceSize)) {
        self.isDesktop = true
      } else {
        self.isDesktop = false
      }
    }, 100),
  },
}
